import financialFA from './fa/fa.json'

const FinancialMessages = {
  fa: { ...financialFA },
}

export default FinancialMessages
